/**
 * Builds the `search_result_clicked` event fired when a project is opened from
 * the /browse list — see Browse/index.tsx.
 *
 * Paired with `search_performed`, this is what makes search measurable rather
 * than merely counted: a query with results nobody opens and a query with no
 * results at all are the same row today, and they call for opposite fixes.
 */

import { getSessionId } from "./session";
import type { SearchResultClickedEvent } from "./types";

interface SearchResultClickedInput {
  projectId: number;
  query: string;
  position: number;
  resultCount: number;
}

export const buildSearchResultClickedEvent = ({
  projectId,
  query,
  position,
  resultCount,
}: SearchResultClickedInput): SearchResultClickedEvent => ({
  name: "search_result_clicked",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: projectId,
  properties: { query, position, result_count: resultCount },
});
